/*
 *   File : why-mandate-invest.js
 *   Author : https://evoqins.com
 *   Description : why-mandate-invest modal
 *   Integrations : @react-oauth/google
 *   Version : 1.0.0
*/

import { memo } from "react";

const WhyMandatoryInvestModal = (props) => {


    return (
        <div className="modal fade"
            id="why-mandatory-invest"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="Why mandatory invest Modal Label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header justify-content-center pt-sm-4  pt-3 px-4 pb-0 border-0 position-relative">
                        <h6 className='e-font-14-res mb-sm-2 mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            Why Mandatory invest?
                        </h6>
                        <img src={require("../../Assets/Images/close-btn-white.svg").default}
                            id='logout-confirmation-modal-close'
                            draggable={false}
                            className='cursor-pointer position-absolute top-0 end-0 m-sm-4 m-3'
                            data-bs-dismiss="modal"
                            aria-label="close"
                            alt='close btn'
                            onClick={props.onClose} />
                    </div>
                    <div className="modal-body p-3 p-sm-4">
                        <p className='e-font-14-res text-center mb-2 e-text-dark-liver e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                            The initial investment is not just a payment, it is the
                            <span className="e-font-weight-500 px-1">final mandatory step in creating and activating your official investment portfolio</span>
                            on our regulated platform. Once this small investment is successfully processed, your investor account
                            is officially registered with the Asset Management Company (AMC) and the platform, which then
                            <span className="e-font-weight-500 px-1">unlocks your personalized home screen and all portfolio tracking features.</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(WhyMandatoryInvestModal);